// implements the FlagProvider typescript interface from '@atlassian/connect-module-core'
class FlagProvider {
	constructor({ showFlag, hideFlag }) {
		this.showFlag = showFlag;
		this.hideFlag = hideFlag;
	}
	create = ({ body: description, actions, ...options }) => {
		this.showFlag({
			...options,
			description,
			actions: actions.map((action) => ({
				key: action.actionKey,
				content: action.actionText,
				onClick: action.executeAction,
			})),
			onClose: () => {
				options.onClose(options.id);
			},
		});
		return {
			flagId: options.id,
			close: () => {
				this.hideFlag(options.id);
			},
		};
	};
}

export { FlagProvider };
